<app-shared-loading *ngIf="loading"></app-shared-loading>
<ng-container *ngIf="template === templateBnpl ">
  <app-bancolombia-bnpl
    [information]="info" 
    [transaction]="transaction">
  </app-bancolombia-bnpl>
</ng-container>